import FooterV2 from '../components/FooterV2';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Section hero pour démonstration */}
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[hsl(var(--primary))] to-[hsl(var(--accent))]">
        <div className="text-center text-white px-6">
          <div className="mb-8">
            <img 
              src="/images/cropped-ChatGPT-Image-24-oct.-2025-19_43_53-e1761384975568.png" 
              alt="Logo Santé des Articulations" 
              className="h-20 w-20 mx-auto mb-6 object-contain"
            />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Santé des <span className="text-[hsl(var(--accent))]">É</span>Articulations
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-blue-100 max-w-2xl mx-auto leading-relaxed">
            Préserver la mobilité naturellement
          </p>
          <p className="text-lg text-blue-200 max-w-3xl mx-auto leading-relaxed">
            Découvrez des solutions naturelles et des conseils d'experts pour maintenir 
            la santé de vos articulations et retrouver une mobilité optimale.
          </p>
          <div className="mt-12 space-x-4">
            <button className="bg-[hsl(var(--accent))] hover:bg-[hsl(var(--accent))]/90 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg">
              Découvrir nos Solutions
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-[hsl(var(--primary))] px-8 py-3 rounded-lg font-semibold transition-all duration-300">
              En Savoir Plus
            </button>
          </div>
        </div>
      </div>
      
      {/* Section de contenu pour démonstration */}
      <div className="py-20 px-6">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[hsl(var(--primary))] mb-6">
              Votre Bien-être Articulaire, Notre Priorité
            </h2>
            <p className="text-lg text-[hsl(var(--muted-foreground))] max-w-3xl mx-auto leading-relaxed">
              Nous vous accompagnons dans votre quête d'une mobilité optimale grâce à des approches naturelles, 
              des conseils d'experts et des solutions personnalisées pour chaque étape de votre parcours santé.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
            <div className="text-center p-6 rounded-lg bg-[hsl(var(--secondary))] hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[hsl(var(--accent))] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-white">🏃</span>
              </div>
              <h3 className="text-xl font-semibold text-[hsl(var(--primary))] mb-3">Exercices Adaptés</h3>
              <p className="text-[hsl(var(--muted-foreground))]">
                Des programmes d'exercices personnalisés pour renforcer et assouplir vos articulations.
              </p>
            </div>
            
            <div className="text-center p-6 rounded-lg bg-[hsl(var(--secondary))] hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[hsl(var(--accent))] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-white">🥗</span>
              </div>
              <h3 className="text-xl font-semibold text-[hsl(var(--primary))] mb-3">Nutrition Ciblée</h3>
              <p className="text-[hsl(var(--muted-foreground))]">
                Découvrez les aliments et compléments qui soutiennent naturellement vos articulations.
              </p>
            </div>
            
            <div className="text-center p-6 rounded-lg bg-[hsl(var(--secondary))] hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 bg-[hsl(var(--accent))] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-white">🧘</span>
              </div>
              <h3 className="text-xl font-semibold text-[hsl(var(--primary))] mb-3">Bien-être Global</h3>
              <p className="text-[hsl(var(--muted-foreground))]">
                Une approche holistique combinant mouvement, relaxation et habitudes de vie saines.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <FooterV2 />
    </div>
  );
};

export default Index;
